module.exports = __webpack_public_path__ + "img/系统简介1.7f6f1f39.png";